<div class="limiter">
    <div class="container-login100">
        <div class="wrap-login100">
            <div class="login100-pic js-tilt" data-tilt>
                <img src="assets/home.png" alt="IMG">
            </div>
  
            <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="login100-form validate-form">
                <span class="login100-form-title">
                    Khurpia's Bill Generator
                </span>
  
                <div class="wrap-input100 validate-input" data-validate = "Valid email is required: ex@abc.xyz">
                    <input formControlName="username" class="input100" type="text" name="username" placeholder="username" >
                    <span class="focus-input100"></span>
                    <span class="symbol-input100">
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                    </span>
                </div>
  
                <div class="wrap-input100 validate-input" data-validate = "Password is required">
                    <input formControlName="password" class="input100" type="password" name="password" placeholder="Password" >
                    <span class="focus-input100"></span>
                    <span class="symbol-input100">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                    </span>
                </div>
                
                <div class="container-login100-form-btn">
                    <button class="login100-form-btn">
                        <!--<button class="login100-form-btn"   [routerLink]="['/home']"  ></button>-->
                        Login
                    </button>
  
                    
                </div>
                </form>
                
          
            <!--login end-->
  
          
        </div>
    </div>
  </div>


  <a style=" display: flex;
  justify-content: center;
  align-items: center;
">
  Developed by Naman Khurpia
</a>